<template>
  <div class="transaction_list">
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <v-row class=" ">
              <v-col cols="12" md="12">
                <div
                  class="grey--text text--darken-1 text-body-2"
                >Saldo Coin Gen: {{saldoCoinGen | toRupiah}}</div>
              </v-col>
            </v-row>
            <div v-if="historyCoinGenData.length == 0 && !historyCoinGenPagination">
              <div class="pb-4">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-col class="pb-0">
                    <vcl :width="300" :height="65">
                      <rect x="0" y="0" rx="2" ry="2" width="60" height="5" />
                      <rect x="260" y="0" rx="2" ry="2" width="40" height="5" />
                      <rect x="5" y="15" rx="2" ry="2" width="80" height="5" />
                      <rect x="5" y="25" rx="2" ry="2" width="95" height="5" />
                      <rect x="5" y="35" rx="2" ry="2" width="155" height="10" />
                      <rect x="5" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="50" rx="2" ry="2" width="45" height="5" />
                      <rect x="5" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="70" y="60" rx="2" ry="2" width="45" height="5" />
                      <rect x="240" y="18" rx="2" ry="2" width="35" height="12" />
                      <rect x="220" y="34" rx="2" ry="2" width="75" height="12" />
                      <rect x="220" y="50" rx="2" ry="2" width="75" height="12" />
                    </vcl>
                  </v-col>
                </v-card>
              </div>
            </div>
            <div v-else-if="historyCoinGenData.length == 0 && historyCoinGenPagination">
              <v-card outlined elevation="0" class="py-3 rounded-lg">
                <v-row class="justify-center">
                  <v-col cols="7" md="5">
                    <v-img width="100%" src="/assets/icons/belum-ada-pesanan.svg"></v-img>
                  </v-col>
                </v-row>
                <div class="text-center pb-3">
                  <div class="pt-1 text-body-1 font-weight-bold">Belum ada pesanan</div>
                  <div class="pt-1 text-body-2">Belanja kebutuhanmu segera</div>
                  <div class="pt-4">
                    <a :href="homepage" class="text-deco">
                      <v-btn
                        depressed
                        large
                        color="black"
                        text
                        outlined
                        class="text-capitalize font-weight-bold rounded-lg"
                      >
                        <v-icon>mdi-cart</v-icon>Belanja Sekarang
                      </v-btn>
                    </a>
                  </div>
                </div>
              </v-card>
            </div>
            <div v-else>
              <div class="pb-4" v-for="data in historyCoinGenData" :key="data.pwallet_cash_log_id">
                <v-card outlined elevation="0" class="py-3 rounded-lg">
                  <v-row class="px-3">
                    <v-col class="py-1 text-body-2 my-auto">
                      <div class="d-block d-md-flex font-weight-bold">
                        <div>Transaksi</div>
                        <div class="pt-1 pt-md-0 pl-md-1">{{ data.pwallet_cash_log_note }}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <div class="px-3 py-2">
                    <v-divider></v-divider>
                  </div>
                  <v-row class="pl-3 pl-md-5 pr-3">
                    <v-col cols="12" sm="7" md="8" class="pl-3 pl-md-5 py-0 text-body-2">
                      <div class="pt-3 d-md-flex">
                        <div class="d-flex">
                          <div class="font-size-13 grey--text text--darken-1">Total :</div>
                          <div
                            v-if="data.pwallet_cash_log_type=='out'"
                            class="pl-3 text-body-2 red--text font-weight-bold"
                          >- {{ data.pwallet_cash_log_value | toRupiah }}</div>
                          <div
                            v-else
                            class="pl-3 text-body-2 green--text font-weight-bold"
                          >+ {{ data.pwallet_cash_log_value | toRupiah }}</div>
                        </div>
                        <div class="pt-1 pt-md-0 d-flex">
                          <div class="pl-md-3 font-size-13 grey--text text--darken-1">Waktu :</div>
                          <div
                            class="pl-3 text-body-2 font-weight-bold"
                          >{{ data.pwallet_cash_log_datetime | tanggal }}</div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="5" md="4" class="text-center text-md-right"></v-col>
                  </v-row>
                </v-card>
              </div>
              <v-row class="pt-4 justify-center" v-if="historyCoinGenPagination.total_page > 1">
                <v-pagination
                  v-model="page"
                  @input="changePage"
                  :length="historyCoinGenPagination.total_page"
                  class="elevation-0"
                ></v-pagination>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import StatusTransaction from "@/components/StatusTransaction";
import ModalDelete from "@/components/ModalDelete";

export default {
  components: {
    ProfileMenu,
    StatusTransaction,
    ModalDelete
  },
  data() {
    return {
      page: 1,
      limit: 5,
      homepage:process.env.VUE_APP_HOMEPAGE,
      params: [],
      sortBy: "trx_id",
      sortDir: "DESC",
      invoice_selected: ""
    };
  },
  computed: {
    ...mapState("transaction", [
      "transactionData",
      "transactionPagination",
      "historyCoinGenData",
      "historyCoinGenPagination"
    ]),
    ...mapState("cart", ["saldoCoinGen"])
  },
  methods: {
    ...mapActions("transaction", [
      "historyCoinGen",
      "getTransaction",
      "cancelTransaction",
      "receiveTransaction",
      "cancelBank",
      "cancelStore",
      "cancelVA"
    ]),
    ...mapActions("cart", ["getSaldoCoinGen"]),
    confirmReceived(id) {
      this.invoice_selected = id;
      this.$refs.ModalReceive.modalShow();
    },
    receive() {
      this.receiveTransaction({ trx_id: this.invoice_selected }).then(() => {
        this.historyCoinGen({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir
        });
      });
    },
    gotoDetail(invoice) {
      this.$router.push({
        name: "transaction-detail",
        params: { id: invoice }
      });
    },
    changePage(page) {
      this.page = page;
      this.historyCoinGen({
        limit: this.limit,
        page: this.page,
        params: this.params
        // sort: this.sortBy,
        // dir: this.sortDir
      });
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Histori Coin Gen");
    this.historyCoinGen({
      limit: this.limit,
      page: this.page,
      params: this.params
    });
    this.getSaldoCoinGen();
  }
};
</script>